import { Route } from "@angular/router";
import { ExportComponent } from "./export.component";

export const ExportRouting: Route = {
  path: 'export',
  component: ExportComponent,
  outlet: 'sidebar',
  data: {
    breadcrumb: "Export",
  }
};
